export function matchNode(current, target) {
    let found = false;

    while (current.parentNode) {
        found = (current == target);
        if (found) {
            break;
        }
        current = current.parentNode;
    }

    return found;
}



// WEBPACK FOOTER //
// ./app/utils/dom.js